import { FaEquals as MinExpandIcon } from 'react-icons/fa';

export default MinExpandIcon;
